export function renderRegisterAddress(address: number) {
  return Number.isNaN(address) ? '-' : String(address)
}
